import { render, staticRenderFns } from "./Colunas.vue?vue&type=template&id=77448eeb&scoped=true"
import script from "./Colunas.vue?vue&type=script&lang=js"
export * from "./Colunas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77448eeb",
  null
  
)

export default component.exports